module.exports = __webpack_public_path__ + "img/symbol_3.af5dfff1.png";